export const ChangeOrders = {
    INITIATE_STATES: 'INITIATE_STATES',
    GOTO_COVER_STATE: 'GOTO_COVER_STATE',
    GOTO_EVENT_STATE: 'GOTO_EVENT_STATE',
    GOTO_STATE: 'GOTO_STATE',
    NAV_TO_STATE: 'NAV_TO_STATE',
    SWIPE_TO_STATE: 'SWIPE_TO_STATE',
    AUTPLAY_TO_STATE: 'AUTPLAY_TO_STATE',
    CLOSE_CURRENT_EVENT: 'CLOSE_CURRENT_EVENT',
    EXPAND_CURRENT_EVENT: 'EXPAND_CURRENT_EVENT',
    COLLAPSE_CURRENT_EVENT: 'COLLAPSE_CURRENT_EVENT',
    FIRST_USER_ACTION: 'FIRST_USER_ACTION',
    SWITCH_SOUND_STATE: 'SWITCH_SOUND_STATE',
    SWITCH_MENU_STATE: 'SWITCH_MENU_STATE',
    OPEN_MENU: 'OPEN_MENU',
    CLOSE_MENU: 'CLOSE_MENU',
    CLOSE_HELPER: 'CLOSE_HELPER'
};
export default ChangeOrders;
